import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function PrivacyPolicy() {
  return (
    <div>
      <SEO
        title="Privacy Policy"
        path="/privacy"
        description="Read the InstaVivah privacy policy: what personal data we collect, how we use it, and the strict controls that keep your matrimonial profile safe."
        keywords="privacy policy, matrimonial data protection, biodata privacy, InstaVivah privacy"
      />
      <Navbar />

      <header className="sb-page-hero text-center">
        <div className="container">
          <div className="sb-kicker mb-2">Your data, respected</div>
          <h1>Privacy Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}</p>
        </div>
      </header>

      <main className="container py-5">
        <article className="sb-prose">
          <p>
            InstaVivah (“we”, “us”) respects your privacy. This policy
            explains what information we collect when you use our matrimonial
            biodata maker and marriage profile service, how we use it, and the
            choices available to you.
          </p>

          <h2>1. Information we collect</h2>
          <h3>Information you provide</h3>
          <ul>
            <li>Account details: name, email address, encrypted password.</li>
            <li>
              Biodata content: date of birth, gender, religion, caste, family
              details, education, career, lifestyle, partner preferences,
              contact information, and optional photographs.
            </li>
            <li>Payment references for Premium (UPI transaction id / screenshot).</li>
            <li>Any messages you send us via contact forms or email.</li>
          </ul>
          <h3>Information collected automatically</h3>
          <ul>
            <li>Device information, browser, IP address, referrer.</li>
            <li>Basic usage analytics for reliability and product improvement.</li>
          </ul>

          <h2>2. How we use your information</h2>
          <ul>
            <li>To operate the biodata maker and matrimonial search features.</li>
            <li>To let you export biodata as PDF and DOCX.</li>
            <li>
              To connect you with other members only when you initiate or
              accept an interest request.
            </li>
            <li>
              To send transactional notifications (payment verified, interest
              received, password reset).
            </li>
            <li>To detect fraud, abuse, and to enforce our Terms.</li>
          </ul>

          <h2>3. What we never do</h2>
          <ul>
            <li>We do <strong>not</strong> sell your data to third parties.</li>
            <li>
              We do <strong>not</strong> display phone numbers, email
              addresses, home addresses, or photos to the general public.
              These are shown only after mutual consent.
            </li>
            <li>
              We do <strong>not</strong> send unsolicited marketing SMS or
              WhatsApp messages.
            </li>
          </ul>

          <h2>4. Public browsing (no-login search)</h2>
          <p>
            Guests who visit <Link to="/browse">Browse Profiles</Link> see a
            <em> limited </em> summary of each public profile: first name,
            approximate age, gender, religion, caste, city/state, highest
            education and occupation. Phone, email, address, photos and date
            of birth are <strong>never</strong> displayed to guests.
          </p>

          <h2>5. Privacy controls in your profile</h2>
          <ul>
            <li><strong>Private</strong> — visible only to you.</li>
            <li><strong>Shareable link</strong> — accessible only via the exact link.</li>
            <li><strong>Members-only</strong> — visible to logged-in members.</li>
            <li><strong>Public</strong> — discoverable in public search (limited fields).</li>
          </ul>

          <h2>6. Data retention</h2>
          <p>
            We keep your profile as long as your account is active. You may
            request deletion at any time by writing to{" "}
            <a href="mailto:privacy@instavivah.com">
              privacy@instavivah.com
            </a>
            . Once deleted, only anonymised transaction logs required by law
            are retained.
          </p>

          <h2>7. Security</h2>
          <p>
            Passwords are stored using bcrypt one-way hashing. Sessions use
            httpOnly cookies. Backups are encrypted at rest. We restrict
            employee access to production data on a strict need-to-know basis.
          </p>

          <h2>8. Children</h2>
          <p>
            InstaVivah is intended for adults of marriageable age. We do
            not knowingly collect data from minors under 18.
          </p>

          <h2>9. Cookies</h2>
          <p>
            We use a small number of essential cookies for authentication
            (session cookies) and preference storage. We do not use
            third-party advertising cookies.
          </p>

          <h2>10. Changes to this policy</h2>
          <p>
            When we update this policy we’ll change the “Last updated” date
            above and, if material, notify registered users by email.
          </p>

          <h2>11. Contact</h2>
          <p>
            Questions about privacy? Write to{" "}
            <a href="mailto:privacy@instavivah.com">privacy@instavivah.com</a>
            {" "}or use our <Link to="/contact">Contact page</Link>.
          </p>
        </article>
      </main>

      <Footer />
    </div>
  );
}
